// extracted by css-extract-rspack-plugin
export default {"dataList":"V5Scbuyc998yjAj5","dataListWrapper":"qs2J_KzgKNQBC09s","dataListContent":"AAEccgHOZW0DlhaK"};